import * as React from "react";
import {useEffect} from "react";
import ShubhForm from "shubhform";
import {connect} from "react-redux";
import {IReduxState} from "reducers";
import {IInsuraceProduct, ISubscriptionError} from "StateInterface";
import {
    getFieldsForInsurance,
    getRegexFromString, getValueForInsuranceField, productPriceCalculation,
    profileStyle,
} from "insurance/forms/utils";
import {
    clearSelectedInfo,
    clearSubscriptionError,
    saveUserInfo,
    setLoaderActive,
    subscribeInsurance,
} from "insurance/actions";
import {diffYears} from "utils";
import {sliceValueUptoMaxLength} from "userform/utils";
import Modal from "components/Modal";
import {getIdToken} from "service";
import {setAndroidTokenAndVersionBeforeRedirecting, setStoreDataToLocalStorage} from "utils/android";
import {fillDetailsEvent, proceedToPayEvent} from "insurance/events";

interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    insuranceProducts: IInsuraceProduct[];
    selectedProductIndex: number;
    razorpayUrl: string;
    subscriptionError: ISubscriptionError;
    apiVersion: number;
    isAndroid: boolean;
    allInsurance: any;
    userInfo: any;
}

function UserDetails(props: IConnectProps) {
    const selectedProductIndex = props.selectedProductIndex;
    const product = props.insuranceProducts[selectedProductIndex];
    useEffect(() => {
        window.scrollTo(0, 0);
        setStoreDataToLocalStorage("insuranceState", props.allInsurance);
        if (props.razorpayUrl) {
            if (props.isAndroid) {
                setAndroidTokenAndVersionBeforeRedirecting(props.apiVersion, getIdToken());
            }
            window.open(props.razorpayUrl, "_self");
        }
        return () => props.dispatch(clearSelectedInfo());
    }, [props.razorpayUrl]);

    function handleSubmit(currentValues) {
        const userInputWithLabel = {};
        proceedToPayEvent();
        const userDetails = {
            productId: props.insuranceProducts[props.selectedProductIndex].productId,
        };
        currentValues.forEach((userInput) => {
            userDetails[userInput.name] = getValueForInsuranceField(userInput.value, userInput.inputType);
            userInputWithLabel[userInput.label] = getValueForInsuranceField(userInput.value, userInput.inputType);
        });
        fillDetailsEvent(userInputWithLabel);
        props.dispatch(saveUserInfo(userDetails));
        props.dispatch(subscribeInsurance(userDetails));
    }
    function errorPopup() {
        return(
            <Modal
                active = {props.subscriptionError.status}
                cancellable = {true}
                cancelTitle = "Ok"
                onClose = {() => props.dispatch(clearSubscriptionError())}
            >
                <div className="text-dark pl-4 pt-4">
                    <h5>Something went wrong !</h5>
                    {props.subscriptionError.msg && props.subscriptionError.msg.map((msg, index) => {
                        return <p key={index} className="p-0 m-0" style={{fontSize: "15px"}}>{msg}</p>;
                    })}
                </div>
            </Modal>
        );
    }
    return(
        props.insuranceProducts ?
            <div>
                <ShubhForm
                    fields={getFieldsForInsurance(product.inputFields, props.userInfo)}
                    onSubmit={handleSubmit}
                    onValidate={handleValidation}
                    customStyles={profileStyle()}
                    onChangeHook={onChangeHook}
                    submitTitle="PROCEED TO PAY"
                    headerTitle="Please fill the details"
                    additionalBottomField={productPriceCalculation(product.productPrice)}
                />
                {props.subscriptionError && props.subscriptionError.status && errorPopup()}
            </div> : <div/>
    );
}

function onChangeHook(fieldDetails) {
    if (fieldDetails.name.includes("pan") ||
        fieldDetails.name.includes("mobile") ||
        fieldDetails.name.includes("pin")) {
        fieldDetails.value = sliceValueUptoMaxLength(fieldDetails.value,
            fieldDetails.max_length ? fieldDetails.max_length : 10).toUpperCase();
    }
    return fieldDetails;
}

function handleValidation(currentValues) {
    let validation = {status: true, errors: null};
    for (const i of currentValues) {
        i.value = String(i.value).trim();
        if (i.value === "") {
            validation = {status: false, errors: {[i.name]: "Mandatory"}};
            break;
        } else if (i.regex !== null && i.regex !== undefined && !new RegExp(getRegexFromString(i.regex)).test(i.value)) {
            validation = {
                status: false,
                errors: {[i.name]: "Invalid"},
            };
            break;
        } else if (
            i.inputType === "date" &&
            (diffYears(new Date(), new Date(i.value)) < i.min || diffYears(new Date(), new Date(i.value)) > i.max)
        ) {
            validation = {
                status: false,
                errors: {[i.name]: `Age should be between ${i.min} and ${i.max}`},
            };
            break;
        }
    }
    return validation;
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        userId: state.login.auth ? state.login.auth.userId : null,
        insuranceProducts: state.insurance.insuranceProducts,
        selectedProductIndex: state.insurance.selectedProductIndex,
        razorpayUrl: state.insurance.razorpayUrl ? state.insurance.razorpayUrl : "",
        subscriptionError: state.insurance.subscriptionError,
        apiVersion: state.login.apiVersion,
        isAndroid: state.login.isAndroid,
        allInsurance: state.insurance,
        userInfo: state.insurance.userInputDetails,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(UserDetails);
